import 'swiper/css';

import type React from 'react';
import {useRef} from 'react';
import {A11y, FreeMode, Navigation} from 'swiper/modules';
import {Swiper} from 'swiper/react';
import type {SwiperModule} from 'swiper/types';

import styles from './SwiperCarousel.module.scss';

type SwiperCarouselProps = {
    options?: Record<string, unknown>;
    className?: string;
    children?: React.ReactNode;
    modules?: SwiperModule[];
};

const SwiperCarousel = ({options, className, children, modules = []}: SwiperCarouselProps) => {
    const sliderRef = useRef(null);
    const builtinOptions = {
        modules: [FreeMode, Navigation, A11y, ...modules],
        pagination: {},
        direction: 'horizontal' as const,
        slidesPerView: 'auto' as const,
        spaceBetween: 16,
        navigation: false,
        freeMode: {enabled: true},
        mousewheel: false,
        breakpoints: {
            0: {slidesOffsetBefore: 16, slidesOffsetAfter: 16},
            744: {slidesOffsetBefore: 0, slidesOffsetAfter: 0},
        },
    };

    const mergedOptions = {...builtinOptions, ...options};

    return (
        <Swiper {...mergedOptions} ref={sliderRef} className={`isolate ${styles.Carousel} ${className ?? ''}`}>
            {children}
        </Swiper>
    );
};

export default SwiperCarousel;
